import { cityConstants } from '../constants';

export function GetCities(state = {}, action) {
  switch (action.type) {
    case cityConstants.GETALL_CITIES_REQUEST:
      return {
        state,
        loading: true,
      }
    case cityConstants.GETALL_CITIES_SUCCESS:
      return {
        ...state,
        items: action.items,
        loading: false
      }
    case cityConstants.GETALL_CITIES_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function GetProvinces(state = {}, action) {
  switch (action.type) {
    case cityConstants.GETALL_PROVINCES_REQUEST:
      return {
        state,
        loading: true,
      }
    case cityConstants.GETALL_PROVINCES_SUCCESS:
      return {
        ...state,
        items: action.items,
        loading: false
      }
    case cityConstants.GETALL_PROVINCES_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}